import { parseISO } from 'date-fns'

/**
 * Parses a date value from various formats into a Date object.
 * Handles null/undefined, Date objects, ISO strings, and other date strings.
 *
 * @param {*} value - The value to parse (Date, string, null, undefined)
 * @returns {Date|null} A Date object or null if parsing fails
 */
export function parseDate(value) {
  if (value instanceof Date) return value
  if (typeof value === 'string') {
    const parsed = parseISO(value)
    if (!isNaN(parsed)) return parsed
    const fallback = new Date(value)
    if (!isNaN(fallback)) return fallback
  }
  return null
}

/**
 * Sets up a change listener on a ReactDateTimePicker hidden input
 *
 * @param {string} wrapperId - The ID of the date input wrapper element
 * @param {Function} callback - The function to call when the input changes
 * @returns {HTMLInputElement} The hidden input element with listener attached
 */
export function setupDateInputChangeListener(wrapperId, callback) {
  const wrapper = document.getElementById(wrapperId)
  const dateInput = wrapper.querySelector('input[type="hidden"].react-date-time')

  dateInput.addEventListener('change', callback)
  return dateInput
}
